import { escapeHtml, getProp } from "../lib/frontendUtilities.js";
import { findCVNames } from "../lib/pubMed.js";
import { getKey } from "../lib/utilities.js";

export default function (opts) {
  opts = opts || {};

  return function ({
    contextMethods,
    contextConstants,
    contextState,
    backend
  }) {
    let { refreshSection, checkSave } = contextMethods;
    let { cvOwner } = contextConstants;
    let { canEdit, newDef, pmidList } = contextState;

    $("#highlightNameList").empty();
    var citationNames = getKey(newDef, "citationName", "")
      .split(";")
      .filter((n) => n != "");

    newDef.citationName = citationNames.join(";");
    citationNames.map(function (highlightName) {
      $("#highlightNameList").append(
        $(
          "" +
            '<div class="btn btn-default ' +
            (!canEdit ? "" : "removeHighlightName") +
            '" data-name="' +
            escapeHtml(highlightName) +
            '" style="margin-bottom: 5px;margin-right: 5px;">' +
            "  <span>" +
            escapeHtml(highlightName) +
            "</span>" +
            (!canEdit
              ? ""
              : '  <span class="glyphicon glyphicon-remove" style="margin-left: 5px;"></span>') +
            "</div>"
        )
      );
    });
    $(".removeHighlightName")
      .unbind("click")
      .click(function () {
        var name = getProp(this, "name");
        newDef.citationName = getKey(newDef, "citationName", "")
          .split(";")
          .filter((n) => n != name)
          .join(";");
        checkSave();
        refreshSection();
      });

    var possibleNames = findCVNames(newDef, pmidList).possibleNames;
    $("#highlightSuggestedNames").toggle(possibleNames.length > 0);
    $("#highlightSuggestedNames").empty();
    possibleNames.map(function (name) {
      $("#highlightSuggestedNames").append(
        $(
          '<div class="btn btn-primary addSearchName" data-name="' +
            escapeHtml(name) +
            '" style="margin-bottom: 5px;margin-right: 5px;">' +
            '  <span class="glyphicon glyphicon-plus" style="margin-right: 5px;"></span><span>' +
            escapeHtml(name) +
            "</span> " +
            "</div>"
        )
      );
    });
    $("#highlightSuggestedNames")
      .find(".addSearchName")
      .click(function () {
        var name = getProp(this, "name");
        newDef["citationName"] = newDef["citationName"]
          .split(";")
          .concat([name])
          .join(";");
        checkSave();
        refreshSection();
      });

    $("#highlightInput").parent().parent().toggle(canEdit);

    $("#orcidSection").hide();
    $("#ncbiSection").hide();
    $("#asterixSection").hide();
    $("#firstNameSection").hide();
    $("#citationPreferencesSection").hide();
    $("#highlightSection").show();
  };
}
